import React from "react";
import { useNavigate } from "react-router-dom";
import { SectionHeading } from "../../shared/components/SectionHeading";
import Button from "../../shared/ui/Button";
import { useTranslation } from "../../i18n";

const SuccessMark = () => (
  <div
    className="mx-auto mb-8 flex h-[72px] w-[72px] items-center justify-center rounded-[16px] bg-white shadow-[0_12px_40px_rgba(0,0,0,0.08)]"
    aria-hidden
  >
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="15" stroke="#111111" strokeWidth="1.8" />
      <path
        d="M12 20.5L17.5 26L28 15"
        stroke="#111111"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);

const SignupSuccessView = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="relative text-center">
      <div className="pointer-events-none absolute -top-6 left-1/2 h-[140px] w-[140px] -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(236,236,236,0.9)_0%,transparent_70%)]" />

      <div className="relative">
        <SuccessMark />

        <SectionHeading className="mb-3 text-[28px] font-semibold leading-tight tracking-[-0.03em] text-[#111111]">
          {t("signup.successTitle")}
        </SectionHeading>
        <p className="mb-10 text-[14px] leading-7 text-[#4b5563]">
          {t("signup.successSubtitle")}
        </p>

        <Button
          type="button"
          showArrow
          onClick={() => navigate("/anmelden")}
          className="mt-2"
        >
          {t("auth.login")}
        </Button>
      </div>
    </div>
  );
};

export default SignupSuccessView;
